.btn {
  display: inline-flex; align-items: center; justify-content: center; gap: var(--space-2);
  border: 1px solid transparent; border-radius: var(--radius-md);
  font-weight: var(--weight-semibold); white-space: nowrap; user-select: none;
  transition: background var(--duration-fast), border-color var(--duration-fast), color var(--duration-fast), box-shadow var(--duration-fast), transform var(--duration-fast);
}
.btn:active:not(:disabled) { transform: translateY(1px); }
.btn:disabled { cursor: not-allowed; opacity: 0.55; }
.sm { height: 36px; padding: 0 var(--space-3); font-size: var(--text-sm); }
.md { height: 44px; padding: 0 var(--space-4); font-size: var(--text-sm); }
.lg { height: 52px; padding: 0 var(--space-5); font-size: var(--text-md); border-radius: var(--radius-lg); }
.block { width: 100%; }
.primary { background: var(--color-primary); color: var(--color-primary-fg); box-shadow: var(--shadow-xs); }
.primary:hover:not(:disabled) { background: var(--color-primary-hover); }
.secondary { background: var(--color-surface); color: var(--color-text); border-color: var(--color-border-strong); box-shadow: var(--shadow-xs); }
.secondary:hover:not(:disabled) { background: var(--color-surface-subtle); }
.ghost { background: transparent; color: var(--color-text-secondary); }
.ghost:hover:not(:disabled) { background: var(--color-surface-sunken); color: var(--color-text); }
.danger { background: var(--color-danger); color: #fff; }
.danger:hover:not(:disabled) { filter: brightness(0.95); }
.subtle { background: var(--color-primary-subtle); color: var(--color-primary-subtle-fg); }
.subtle:hover:not(:disabled) { filter: brightness(0.97); }
.icon { width: 40px; padding: 0; }
.icon.sm { width: 36px; }
.spinner { width: 16px; height: 16px; border-radius: 50%; border: 2px solid currentColor; border-right-color: transparent; animation: spin 0.7s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
